(function () {
  'use strict';

  var STYLE_ID = 'mapsy-vitals-backinstock-guard-style';
  var SUCCESS_CLASS = 'mapsy-bis-success-active';
  var SUCCESS_SELECTOR = '.mapsy-bis-success-panel';
  var MODAL_SELECTOR = '.Vtl-BackInStockModal';

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      'body.Vtl-Modal--Active .product-cart-sticky{opacity:0!important;pointer-events:none!important;transform:translateY(110%)!important;}',
      '.Vtl-BackInStockModal.' + SUCCESS_CLASS + ' .Vtl-BackInStockModalContent__Body{padding-top:18px!important;}',
      '.mapsy-bis-success-panel{margin:0 20px 18px;padding:16px 18px;border:1px solid #b7e4c7;background:#f0fff4;color:#17351f;border-radius:8px;font-size:16px;line-height:1.45;}',
      '.mapsy-bis-success-panel strong{display:block;margin-bottom:4px;font-size:18px;}',
      '@media (max-width: 520px){.mapsy-bis-success-panel{margin-left:20px;margin-right:20px;font-size:15px;}.mapsy-bis-success-panel strong{font-size:17px;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function hasSuccessText(modal) {
    var text = (modal && modal.textContent ? modal.textContent : '').toLowerCase();
    return text.indexOf('bedankt voor uw inschrijving') !== -1
      || text.indexOf('u bent er helemaal klaar voor') !== -1
      || text.indexOf('notificatie te ontvangen') !== -1;
  }

  function scrollModalToTop(modal) {
    if (!modal) return;
    var scrollTargets = [
      modal,
      modal.querySelector('.Vtl-Modal__ContentWrapper'),
      modal.querySelector('.Vtl-Modal__Content'),
      modal.querySelector('.Vtl-BackInStockModalContent'),
      modal.querySelector('.Vtl-BackInStockModalContent__Body')
    ];
    scrollTargets.forEach(function (node) {
      if (node) node.scrollTop = 0;
    });
  }

  function ensureSuccessPanel(modal) {
    if (!modal || !hasSuccessText(modal)) return;
    modal.classList.add(SUCCESS_CLASS);
    scrollModalToTop(modal);

    if (modal.querySelector(SUCCESS_SELECTOR)) return;
    var body = modal.querySelector('.Vtl-BackInStockModalContent__Body') || modal.querySelector('.Vtl-Modal__Content') || modal;
    var panel = document.createElement('div');
    panel.className = 'mapsy-bis-success-panel';
    panel.setAttribute('role', 'status');
    panel.setAttribute('aria-live', 'polite');
    panel.innerHTML = '<strong>Gelukt, je bent aangemeld.</strong><span>We mailen je zodra deze maat en kleur weer op voorraad is.</span>';
    body.insertBefore(panel, body.firstChild);
  }

  function update() {
    injectStyle();
    var modal = document.querySelector(MODAL_SELECTOR);
    if (!modal) return;
    if (hasSuccessText(modal)) {
      requestAnimationFrame(function () {
        ensureSuccessPanel(modal);
      });
    }
  }

  function bindSubmitScrollHint() {
    document.addEventListener('click', function (event) {
      var button = event.target && event.target.closest ? event.target.closest('.Vtl-BackInStockSubscribeForm__Button') : null;
      if (!button) return;
      var modal = button.closest(MODAL_SELECTOR);
      if (!modal) return;
      setTimeout(function () {
        scrollModalToTop(modal);
        update();
      }, 650);
      setTimeout(update, 1800);
      setTimeout(update, 3500);
    }, true);
  }

  injectStyle();
  bindSubmitScrollHint();
  update();
  new MutationObserver(update).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
